import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";

function DateTime() {

  


  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState();

  const [finalResult, getFinalResult] = useState();

  function handleEndDateChange(date) {
    setEndDate(date);
    console.log(startDate, "   ", endDate);
    calculateDays(startDate, date);
  }

  function calculateDays(startDate, endDate) {
    const oneDay = 1000 * 60 * 60 * 24;
    const differenceMs = endDate.getTime() - startDate.getTime();
    const differenceDays = Math.round(differenceMs / oneDay);
    getFinalResult(differenceDays);
  }

  return (
    <>

      <h2>Calculate Days</h2>


      <div className="datePickerDiv">
      
      <p>From &nbsp;</p>
        <DatePicker className="datePickerSelf dark-input" 
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          todayButton="Today"
          withPortal
          dateFormat="dd/MM/yyyy"
          onFocus={(e) => e.target.readOnly = true}
        />
      <p> &nbsp; till  &nbsp;</p>
        <DatePicker className="datePickerSelf dark-input"
          selected={endDate}
          onChange={(date) => handleEndDateChange(date)}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          todayButton="Today"
          withPortal
          dateFormat="dd/MM/yyyy"
          onFocus={(e) => e.target.readOnly = true}
        />

        </div>

        <div className="div-display">

        <p className=""> will be</p>

        <p className="readOnly">&nbsp; {finalResult} &nbsp;</p>
        <p>Days</p>

        </div>

         

      

     
      
    </>
  );
}

export default DateTime;
